import { SimStatus, SimType } from '@EcamModel/model/CameraSIM';
import { BaseSelect, Filter } from '@pages/cameras/list';

export type FilterSIM = Filter & {
    type?: BaseSelect;
};

export enum SIMSearchType {
    SerialNumber,
    PhoneNumber,
    NetworkProvider,
}

export const simSearchTypes: BaseSelect[] = [
    {
        Id: 1,
        Name: 'Serial number',
        Value: SIMSearchType.SerialNumber,
    },
    {
        Id: 2,
        Name: 'Phone number',
        Value: SIMSearchType.PhoneNumber,
    },
    {
        Id: 3,
        Name: 'Network provider',
        Value: SIMSearchType.NetworkProvider,
    },
];

export const optionsSIMStatus: BaseSelect[] = [
    {
        Id: 1,
        Name: 'Active',
        Value: SimStatus.Active,
    },
    {
        Id: 2,
        Name: 'Inactive',
        Value: SimStatus.Inactive,
    },
    {
        Id: 3,
        Name: 'In Stock',
        Value: SimStatus.InStock,
    },
    {
        Id: 4,
        Name: 'Lost',
        Value: SimStatus.Lost,
    },
];

export const optionsSIMType: BaseSelect[] = [
    {
        Id: 1,
        Name: 'O2',
        Value: SimType.O2,
    },
    {
        Id: 2,
        Name: 'GoTo',
        Value: SimType.GoTo,
    },
    {
        Id: 3,
        Name: 'Others',
        Value: SimType.Others,
    },
];

export const tableHeadSIMManagement = [
    'Network provider',
    'Serial number',
    'Phone number',
    'Status',
    'Camera',
    'Type',
    'Created date',
    'Created by',
    '',
];

export const mappingSIMStatus: Record<SimStatus, string> = {
    [SimStatus.Active]: 'Active',
    [SimStatus.Inactive]: 'Inactive',
    [SimStatus.InStock]: 'In Stock',
    [SimStatus.Lost]: 'Lost',
};

export const mappingSIMType: Record<SimType, string> = {
    [SimType.O2]: 'O2',
    [SimType.GoTo]: 'Goto',
    [SimType.Others]: 'Other',
};
